import { useState, useRef } from 'react';
import { ENV } from '@forwardflow/helpers/configs'
interface CallReportWithLead {
  leadId: number;
  report: any;
}

export const useDemoCallSSE = () => {
  const [isListening, setIsListening] = useState(false);
  const [isWaitingForReport, setIsWaitingForReport] = useState(false);
  const eventSourceRef = useRef<EventSource | null>(null);
  const activeCallLeadIdRef = useRef<number | null>(null);
  

  const [endOfCallReport, setEndOfCallReport] = useState<CallReportWithLead | null>(null);

  const startSSEListener = (connectionId: string, leadId: number) => {
    console.log(`Starting SSE listener for lead ${leadId} with connection ${connectionId}`);
    
    setIsListening(true);
    setIsWaitingForReport(true);
    setEndOfCallReport(null);
    
    activeCallLeadIdRef.current = leadId;

    const eventSource = new EventSource(`${ENV.CALL_WORKER_API_URL}/sse/${connectionId}`);
    eventSourceRef.current = eventSource;

    eventSource.addEventListener('connected', (event) => {
      const data = JSON.parse(event.data);
      console.log(`Connected for lead ${leadId}:`, data);
    });

    eventSource.addEventListener('call-status-update', (event) => {
      const data = JSON.parse(event.data);
      console.log(`Status Update for lead ${leadId}:`, data);

      if (data.type === 'end-of-call-report') {
        const callReportWithLead: CallReportWithLead = {
          leadId: activeCallLeadIdRef.current!,
          report: data
        };
        
        console.log(`Call report received for lead ${activeCallLeadIdRef.current}:`, data);
        setEndOfCallReport(callReportWithLead);
        setIsWaitingForReport(false);
        stopListening();
      }
    });

    eventSource.addEventListener('call-ended', () => {
      console.log(`Call ended for lead ${leadId}`);
      setIsWaitingForReport(false);
      stopListening();
    });

    eventSource.onerror = (error) => {
      console.error(`SSE Error for lead ${leadId}:`, error);
      setIsWaitingForReport(false);
      stopListening();
    };
  };

  const stopListening = () => {
    if (eventSourceRef.current) {
      eventSourceRef.current.close();
      eventSourceRef.current = null;
    }
    activeCallLeadIdRef.current = null;
    setIsListening(false);
    setIsWaitingForReport(false);
  };

  return {
    isListening,
    isWaitingForReport,
    endOfCallReport,
    startSSEListener,
    stopListening,
    activeCallLeadId: activeCallLeadIdRef.current
  };
};